.about-modal {
  .main {
    display: grid;
    align-items: center;
    grid-template-columns: auto 600px;
    border-bottom: 1px solid var(--color-grey-light);
    padding-top: 0.5em;
    padding-bottom: 1em;
  }

  .version {
    display: grid;
    grid-template-columns: 150px 40px;
    grid-template-rows: 15px 15px 15px;
  }

  .product {
    padding-right: 10px;
    text-align: right;
    font-size: x-small;
  }

  .status {
    text-align: left;
    font-size: x-small;
  }

  .logo {
    align-self: start;
    width: 65px;
    margin: auto;
    padding-right: 20px;
  }

  .firma {
    width: 260px;
    font-size: x-small;
    color: var(--color-grey);
  }

  .spacer {
    width: calc(100% - 340px);
  }

  div[class*="Modal-module_header"] {
    margin-bottom: 0;
  }
}
